module.exports = __webpack_public_path__ + "img/HUN.6cbb7db5.svg";